<template>
    <div class="bodyheight relative">
        <bg-global :bgLobby="bgLobby" />

        <div
            class="bodyheight flex flex-col items-center justify-start gap-2 p-2 text-black dark:text-white overflow-auto z-10 relative">

            <jackpot class="mb-2" :jackpot="jackpot" />

            <div class="w-full bg-transparent border-2 border-outter-border p-2 rounded-lg">
                <div class="bg-gray-500 bg-no-repeat bg-blend-multiply bg-cover flex flex-col gap-1 items-center border-2 py-1 px-2 select-none border-inner-border relative"
                    :style="{ backgroundImage: `url(${bgImage})` }">
                    <div class="uppercase text-xl">{{ game.name }}</div>

                    <div class="flex items-center gap-1">
                        <span class="text-inner-border font-normal text-sm uppercase">Entry:</span>
                        <span v-if="!game.is_private && ticketAvailable(game)" class="flex items-center gap-1">
                            <span class="font-semibold text-sm">1x</span>
                            <img :src="'/images/prize-' + game.slug + '.png'" class="block h-4 w-4" />
                        </span>
                        <span class="flex items-center gap-1" v-else>
                            <span class="font-semibold text-sm">{{ entry(game) }}</span>
                            <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                            <span class="flex items-center gap-1 text-sm">
                                <span>+ {{ entryFee(game) }}</span>
                                <img src="/images/sol.png" class="block h-3 w-3 rounded-full" />
                            </span>
                        </span>
                    </div>

                    <div class="flex items-center gap-2" v-if="game.is_special">
                        <span class="text-inner-border font-semibold">Starts At:</span>
                        <span class="font-semibold">{{ toDate(game.starts_at) }}</span>
                    </div>

                    <div class="flex items-center gap-2">
                        <span class="text-inner-border font-semibold">Total Racers:</span>
                        <span class="font-semibold">{{ game_queue.length }}/{{ game.max_players }}</span>
                        <span class="text-xs">(Min: {{ game.min_players }})</span>
                    </div>

                    <div class="flex items-center justify-center mb-4" v-if="isTeamWallet && game.is_special">
                        <button @click="spectateGame"
                            class="mt-2 py-1 px-4 bg-green-600 text-white rounded text-base uppercase border border-green-800 disabled:opacity-60">
                            <span v-if="!isSpectating">Spectate</span>
                            <span v-else>Spectating</span>
                        </button>
                    </div>

                    <div class="absolute top-1 right-1 bg-black bg-opacity-25 rounded-full text-red-600 w-6 h-6 flex items-center justify-center"
                        @click="click('games-list-clicked')">
                        <i class="far fa-reply fa-fw leading-5"></i>
                    </div>
                </div>
            </div>

            <div class="flex flex-col items-center gap-2 w-full" v-if="!game.is_special">
                <h2
                    class="flex items-center border-2 border-outter-border border-b-0 rounded-tl-lg rounded-tr-lg translate-y-2">
                    <span class="bg-gradient-to-t from-black to-jackpot-bg font-semibold text-white text-sm px-4 py-1 uppercase gap-0 rounded-tl-lg rounded-tr-lg">Prizes</span>
                </h2>

                <ul class="w-full flex flex-col gap-2 bg-transparent border-2 border-outter-border p-2 rounded-lg">
                    <li class="bg-lobby-bg border-2 py-1 px-2 select-none border-inner-border">
                        <div class="flex gap-2 items-center justify-center">
                            <span class="text-xs font-mono">1st</span>
                            <span class="font-semibold">{{ prize }}</span>
                            <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                            <span class="flex gap-2 items-center" v-if="rrTokenImage !== null">
                                <span class="text-xs font-mono">+</span>
                                <img :src="rrTokenImage" class="block h-5 w-5 rounded-full" />
                                <span v-if="game.token_percentage > 0" class="text-xs font-mono">{{ game.token_percentage }}%</span>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <h2
                class="flex items-center border-2 border-outter-border border-b-0 rounded-tl-lg rounded-tr-lg translate-y-2">
                <span class="bg-gradient-to-t from-black to-jackpot-bg font-semibold text-white text-sm px-4 py-1 uppercase gap-0 rounded-tl-lg rounded-tr-lg">Racers</span>
            </h2>

            <div class="w-full bg-transparent border-2 border-outter-border p-2 rounded-lg">
                <ul class="bg-lobby-bg flex flex-col border-2 select-none border-inner-border">
                    <li v-for="index in game.max_players" :key="'queue-players-' + index"
                        class="bg-lobby-bg flex items-center justify-between gap-2 select-none px-2 py-1">
                        <div class="flex gap-2 items-center">
                            <span class="text-inner-border text-sm">Player {{ index }}:</span>
                            <span v-if="game_queue[index - 1] ? true : false" :class="{ 'text-green-500': whoAmI(index) }">
                                {{ game_queue[index - 1].user.name }}
                            </span>
                            <span class="text-xs text-gray-500 uppercase" v-if="game_queue[index - 1] ? false : true">Open slot</span>
                        </div>
                        <div class="text-gray-500">
                            <img v-if="(game_queue[index - 1] ?? false) && game_queue[index - 1].user.pfp !== null"
                                class="block rounded-full object-cover w-8 h-8 border-2"
                                :class="{ 'border-green-500': whoAmI(index) }" :src="game_queue[index - 1].user.pfp" />
                            <img v-else-if="(game_queue[index - 1] ?? false) && game_queue[index - 1].user.pfp === null"
                                class="block rounded-full object-cover w-8 h-8 border-2 border-white"
                                src="/images/bear.jpg" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="w-8 h-8">
                                <path fill-rule="evenodd"
                                    d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </li>
                    <li class="flex items-center justify-center mb-4 p-2" v-if="game.is_private && !game.is_special && !joined">
                        <input v-model="game_password" maxlength="20" min="0" type="text" class="mt-1 block text-sm text-black w-full rounded border border-gray-400 p-2 outline-none focus-none sm:text-sm" placeholder="Enter game password..." />
                    </li>
                    <li class="flex items-center justify-center mb-4">
                        <button @click="joinGame(game.id)" :disabled="joinAgainDisabled || (game.is_private && !game.is_special && !game_password.length) || joining"
                            class="mt-2 py-1 px-4 bg-green-600 text-white rounded text-base uppercase border border-green-800 disabled:opacity-60">
                            <span v-if="!joinAgainDisabled && joined">Join Again</span>
                            <span v-else-if="joinAgainDisabled && joined && game_queue.length < game.max_players">Waiting for Opponent{{ game.max_players > 2 ? 's' : '' }}</span>
                            <span v-else-if="joinAgainDisabled && game_queue.length == game.max_players">Starting Soon</span>
                            <span v-else>Join Game</span>
                        </button>
                    </li>
                    <li class="mb-4 flex items-center justify-center">
                        <span class="inline-flex items-center justify-center gap-1 text-sm"
                            @click.prevent="toggleAutoStart">
                            <span>Start watching race automatically</span>
                            <i v-if="start_game" class="text-base fas fa-fw fa-square-check text-inner-border"></i>
                            <i v-else class="text-base fas fa-fw fa-square text-gray-200"></i>
                        </span>
                    </li>
                </ul>
            </div>

            <div class="text-sm font-normal text-center text-inner-border" v-if="!game.is_special">Game starts when all racer slots are filled</div>
            <div class="text-sm font-normal text-center text-inner-border" v-else>Game starts automatically at scheduled date</div>

        </div>

    </div>
</template>

<script>
import * as dayjs from 'dayjs'
import axios from 'axios'
import solana from '../mixins/solana'
import Jackpot from './Jackpot.vue'
import { useWallet } from 'solana-wallets-vue'

export default {
    name: 'GameLobby',
    components: { Jackpot },
    props: {
        game: {
            type: Object,
            required: true
        },
        token: {
            type: String,
            required: true
        },
        connected: {
            type: Boolean,
            required: true
        },
        subdomain: {
            type: String,
            required: true
        },
        queue: {
            type: Object,
            required: true
        },
        private_queue: {
            type: Object,
            required: true
        },
        spectate_queue: {
            type: Object,
            required: true
        },
        jackpot: {
            type: Object,
            required: true
        },
        bgLobby: {
            type: String,
            required: true
        },
        tokens: {
            type: Array,
            required: true
        },
        ticketsBalance: {
            type: Object,
            required: true
        },
        start_game: {
            type: Boolean,
            required: true
        },
        isTeamWallet: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            specialsFree: (process.env.MIX_SPECIALS_FREE === 'true'),
            game_fee: process.env.MIX_GAME_FEE,
            game_password: '',
            joining: false
        }
    },
    mixins: [solana],
    computed: {
        wallet() {
            return useWallet().publicKey.value?.toString()
        },
        prize() {
            return this.lamportsToSol(this.game.entry * this.game.max_players)
        },
        game_queue() {
            if (this.game.is_private) {
                if (!Object.keys(this.private_queue).length) {
                    return []
                }
                return this.private_queue[this.game.id]
            }
            if (!Object.keys(this.queue).length) {
                return []
            }
            return this.queue[this.game.id]
        },
        joinAgainDisabled() {
            if (this.game.max_players == this.game_queue.length) {
                return true;
            }
            if (this.game.is_private && this.game.multiple) {
                return false
            }
            if (this.game.max_players - this.joined <= 1) {
                return true;
            }
            return this.joined == 1 && this.game.is_private
        },
        isSpectating() {
            return this.game.id in this.spectate_queue && Array.isArray(this.spectate_queue[this.game.id]) && this.spectate_queue[this.game.id].includes(this.wallet);
        },
        joined() {
            return this.game_queue.filter((item) => {
                return item.wallet === this.wallet
            }).length
        },
        bgImage() {
            return '/images/games/bg-' + this.game.slug + '.jpg'
        },
        rrTokenImage() {
            const found = this.tokens.find(item => item.slug === this.game.token)
            if (found === undefined) {
                return null
            }
            return found.image
        }
    },
    watch: {
        async connected(value) {
            if (!value) {
                this.emitter.emit('games-list-clicked')
            }
        }
    },
    methods: {
        toDate(date) {
            if (date === null) {
                return '-';
            }
            return dayjs(date).format('YYYY-MM-DD HH:mm')
        },
        toggleAutoStart() {
            this.emitter.emit('toggle-auto-start')
        },
        whoAmI(index) {
            return (this.game_queue[index - 1] ?? false) && this.game_queue[index - 1].wallet === this.wallet
        },
        spectateGame(id) {
            if (!this.connected) {
                this.$toast.error('Connect wallet and sign in')
                return
            }
            axios.post('/api/games/spectate', {
                wallet: useWallet().publicKey.value.toString(),
                id: this.game.id,
            }, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.$toast.success(response.data.message)
            }).catch((err) => {
                if (err.response) {
                    this.$toast.error(err.response.data.message)
                } else {
                    this.$toast.error('Unknown error')
                }
            })
        },
        joinGame(id) {
            if (!this.connected) {
                this.$toast.error('Connect wallet and sign in')
                return
            }
            this.joining = true
            axios.post('/api/games/join', {
                wallet: useWallet().publicKey.value.toString(),
                id: id,
                subdomain: this.subdomain,
                private: this.game.is_private,
                game_password: this.game_password
            }, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((response) => {
                this.$toast.success(response.data.message)
            }).catch((err) => {
                if (err.response) {
                    this.$toast.error(err.response.data.message)
                } else {
                    this.$toast.error('Unknown error')
                }
            }).finally(() => {
                this.game_password = ''
                this.joining = false
            })
        },
        click(event) {
            this.emitter.emit(event)
        },
        ticketAvailable(item) {
            return this.ticketsBalance[item.slug]
        },
        entry(item) {
            if (this.specialsFree && item.is_special) {
                return 0
            }
            return this.lamportsToSol(item.entry)
        },
        entryFee(item) {
            if (this.specialsFree && item.is_special) {
                return 0
            }
            return this.lamportsToSol(item.entry * this.game_fee)
        }
    }
}
</script>
